// extracted by mini-css-extract-plugin
module.exports = {"content":"CampaignPageCustomBlock_content___q5bX"};